/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_History_DescriptionInputs */

const en_audit_history_description = /** @type {(inputs: Audit_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past warehouse physical inventory audit sessions.`)
};

const es_audit_history_description = /** @type {(inputs: Audit_History_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesiones anteriores de auditoria fisica de inventario en almacen.`)
};

/**
* | output |
* | --- |
* | "Past warehouse physical inventory audit sessions." |
*
* @param {Audit_History_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_history_description = /** @type {((inputs?: Audit_History_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_History_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_history_description(inputs)
	return es_audit_history_description(inputs)
});